import React from "react";

function LoaderSmall() {
  return <span className="loader-custom"></span>;
}

export default LoaderSmall;
